import { Trans } from '@lingui/macro';
import ExternalLink from '~/app/shared/components/ExternalLink';
import ErrorGraphic from './images/man-confused.svg';

interface Props {
    children?: string | JSX.Element;
    message: string;
}

export default function ErrorDialog({ children, message }: Props) {
    return (
        <>
            <div className="mb-2">{children}</div>
            <div className="text-center mt-4">
                <h2>
                    <Trans>Oops! Something went wrong</Trans>
                </h2>
            </div>
            <div className="text-center mt-4 mb-6">
                <img src={ErrorGraphic} className="mx-auto" />
            </div>
            <h5 className="mb-0">
                <Trans>What caused the error?</Trans>
            </h5>
            <div className="mb-4">{message}</div>
            <h5 className="mb-0">
                <Trans>We are here to help</Trans>
            </h5>
            <div className="mb-4">
                <Trans>Please contact e-conomic's support for help or try again later. We apologise for the inconvenience.</Trans>
            </div>
            <h5 className="mb-0">
                <Trans>Email:</Trans>
            </h5>
            <div className="mb-4">
                <ExternalLink href="mailto:info@e-conomic.dk">info@e-conomic.dk</ExternalLink>
            </div>
            <h5 className="mb-0">
                <Trans>Telephone:</Trans>
            </h5>
            <div className="mb-4">
                <Trans>+45 88 20 48 40</Trans>
            </div>
        </>
    );
}
